<template>
  <div class="correct-dialog-wrap">
    <div class="card-wrap">
      <div class="card-title">基本信息</div>
      <div class="base-wrap">
        <img :src="studentPracticeDetail.student.avatar_url" class="avatar" />
        <div class="info">
          <p>学员姓名：{{ studentPracticeDetail.student.name }}</p>
          <p>提交时间：{{ studentPracticeDetail.committed_time }}</p>
        </div>
        <div class="status wait" v-if="studentPracticeDetail.status === 3">
          待批改
        </div>
        <div class="status finish" v-if="studentPracticeDetail.status === 4">
          已批改
        </div>
      </div>
    </div>
    <div class="card-wrap" v-if="studentPracticeDetail.status === 4">
      <div class="card-title">点评详情</div>
      <div
        class="comment-wrap"
        style="max-height: 180px; overflow: hidden auto"
      >
        <div class="row">
          <div class="item">
            <div class="label">批改人员:</div>
            <div class="content">
              {{ studentPracticeDetail.corrected_staff.name }}
            </div>
          </div>
          <div class="item">
            <div class="label">批改时间:</div>
            <div class="content">
              {{ studentPracticeDetail.teacher_answer.create_time }}
            </div>
          </div>
          <div class="item">
            <div class="label">练习评星:</div>
            <div class="content">
              <el-rate
                disabled
                v-model="studentPracticeDetail.teacher_answer.star_num"
                :colors="colors"
              >
              </el-rate>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="label">练习评语:</div>
          <div
            class="content"
            v-html="
              studentPracticeDetail.teacher_answer.content.replace(
                /\n/g,
                '<br/>'
              )
            "
          ></div>
        </div>
      </div>
    </div>
    <div class="card-wrap">
      <div class="card-title">练习内容</div>
      <div
        class="content-wrap"
        style="max-height: 180px; overflow: hidden auto"
      >
        <div
          class="item"
          v-for="(item, index) in studentPracticeDetail.student_answer
            .content_list"
          :key="index"
          :class="{ block: item.annex_type === 3 }"
        >
          <div v-if="item.annex_type === 1" class="border">
            <div class="img-box" @click="openInNewPage(item.annex_content)">
              <img :src="item.annex_content" alt="" />
              <div class="open">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
          </div>
          <div v-if="item.annex_type === 2" class="border">
            <div class="video-box" @click="openInNewPage(item.annex_content)">
              <video :src="item.annex_content"></video>
              <div class="open">
                <i class="el-icon-zoom-in"></i>
              </div>
            </div>
            <div
              class="checked-wrap mwow-form"
              v-if="systemAllowRecommend && studentPracticeDetail.status === 3"
            >
              <el-checkbox
                :disabled="!studentAllowRecommend"
                v-model="item.checked"
                @change="handleVideoSelect(index)"
                >推荐到视频社区</el-checkbox
              >
            </div>
          </div>
          <div v-if="item.annex_type === 3">
            <div
              v-html="item.annex_content.replace(/\n/g, '<br/>')"
              class="text-wrap"
            ></div>
          </div>
          <div v-if="item.annex_type === 4">
            <audioPlay :audioItem="item"></audioPlay>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrap" v-if="studentPracticeDetail.status === 3">
      <div class="card-title flex">
        <span style="flex: 1">练习点评</span>
        <div class="mwow-yellow">练习批改后，会将评星与评语推送给学员。</div>
      </div>
      <div class="start-wrap">
        <span class="label">练习评星:</span>
        <el-rate v-model="commentInfo.tinySpot" :colors="colors"></el-rate>
      </div>
      <el-form
        :rules="rules"
        size="mini"
        ref="comment"
        :model="commentInfo"
        class="correct-wrap"
        label-width="96px"
      >
        <el-form-item label="练习评语:" prop="practiceText">
          <el-input
            type="textarea"
            placeholder="请输入"
            v-model="commentInfo.practiceText"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="推荐社区视频:"
          v-if="
            studentAllowRecommend && systemAllowRecommend && homeworkHasVideo
          "
        >
          <el-switch
            v-model="commentInfo.recommend"
            @change="handleRecommendChange"
          ></el-switch>
          <span style="margin-left: 8px">{{
            commentInfo.recommend ? "推荐" : "不推荐"
          }}</span>
        </el-form-item>
        <el-form-item
          label="推荐社区视频:"
          v-if="
            !studentAllowRecommend && systemAllowRecommend && homeworkHasVideo
          "
        >
          <el-switch :value="false" disabled></el-switch>
          <span style="margin-left: 8px" class="mwow-red">家长不同意推荐</span>
        </el-form-item>
        <div
          v-if="
            studentAllowRecommend && systemAllowRecommend && homeworkHasVideo
          "
        >
          <el-form-item
            label="推荐视频标题:"
            prop="videoTitle"
            v-if="allowEditVideoTitle"
          >
            <el-input
              v-model="commentInfo.videoTitle"
              maxlength="18"
              placeholder="请输入视频标题，最多可输入18字"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="推荐视频标题:" v-else>
            <el-input
              disabled
              maxlength="18"
              placeholder="请输入视频标题，最多可输入18字"
            >
            </el-input>
          </el-form-item>
          <el-tag type="warning"
            >取一个好的视频标题，让学员作品更有和曝光哦</el-tag
          >
        </div>
      </el-form>
    </div>
    <div class="bottom-button">
      <div class="mwow-button-filled" @click="handleFinish">取消</div>
      <div
        class="mwow-button-filled primary"
        @click="completingComments"
        v-if="studentPracticeDetail.status === 3"
      >
        完成点评
      </div>
      <div
        class="mwow-button-filled success"
        v-if="
          studentPracticeDetail.status === 3 && originData.deadline_status === 2
        "
        @click="retransmission"
      >
        点评并重发
      </div>
    </div>
  </div>
</template>
<script>
import {
  correct,
  getHomeworkStudentAnswerDetailApi,
  homeworkVideoRecommendApi,
} from "@/api/homework";
import audioPlay from "../addAfter/audioPlay.vue";
import { dateFormat } from "@/utils/timeFormat";
export default {
  props: ["originData"],
  components: {
    audioPlay,
  },
  data() {
    return {
      homeworkHasVideo: false,
      systemAllowRecommend: false,
      studentAllowRecommend: false,
      commentInfo: {
        tinySpot: 0,
        practiceText: "",
        recommend: false,
        videoTitle: "",
      },
      colors: ["#07D1AA", "#07D1AA", "#07D1AA"],
      studentPracticeDetail: {
        student: {
          name: "",
          avatar_url: "",
        },
        student_answer: {
          content_list: [],
        },
        teacher_answer: {
          content: "",
          star_num: 0,
          create_time: "",
        },
        corrected_staff: {
          name: "",
        },
      },
      rules: {
        practiceText: [
          { required: true, message: "请输入练习评语", trigger: "blur" },
        ],
        videoTitle: [
          { required: true, message: "请输入视频标题", trigger: "blur" },
        ],
      },
      allowEditVideoTitle: false,
    };
  },
  created() {
    getHomeworkStudentAnswerDetailApi({
      homework_student_id: this.originData.homework_student_id,
      homework_id: this.originData.homework_id,
    }).then((res) => {
      if (res.error_code === 0) {
        res.data.student_answer.content_list.sort((a, b) => {
          return b.annex_type - a.annex_type;
        });
        res.data.committed_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          res.data.committed_time * 1000
        );
        res.data.teacher_answer.create_time = dateFormat(
          "YYYY-mm-dd HH:MM",
          res.data.teacher_answer.create_time * 1000
        );
        res.data.student_answer.content_list.map((it) => {
          it.checked = false;
        });
        this.homeworkHasVideo = res.data.student_answer.content_list.find(
          (annex) => {
            return annex.annex_type === 2;
          }
        );
        this.studentAllowRecommend = res.data.allow_recommend === 1;
        this.systemAllowRecommend = res.data.community_video_switch === 1;
        this.studentPracticeDetail = res.data;
      }
    });
  },
  methods: {
    handleFinish() {
      this.$emit("close");
    },
    handleVideoSelect(i) {
      let target = this.studentPracticeDetail.student_answer.content_list[i];
      if (target.checked) {
        this.allowEditVideoTitle = true;
        this.commentInfo.recommend = true;
        this.studentPracticeDetail.student_answer.content_list.map((it) => {
          it.checked = false;
        });
        this.studentPracticeDetail.student_answer.content_list[
          i
        ].checked = true;
      } else {
        this.allowEditVideoTitle = false;
        this.commentInfo.recommend = false;
      }
    },
    completingComments() {
      // 检查推荐相关内容
      let recommendTarget;
      if (this.commentInfo.recommend) {
        recommendTarget =
          this.studentPracticeDetail.student_answer.content_list.find(
            (annex) => {
              return annex.checked;
            }
          );
        if (!recommendTarget) {
          this.$message({
            type: "warning",
            message: "请先选择推荐视频",
          });
          return false;
        }
        if (!this.commentInfo.videoTitle) {
          this.$message({
            type: "warning",
            message: "请先填写推荐视频标题",
          });
          return false;
        }
      }
      this.$refs["comment"].validate((valid) => {
        if (valid) {
          this.$confirm(
            `确定完成学员 “${this.studentPracticeDetail.student.name}” 练习的点评，点评后评语将无法修改请确认是否有输入错误。确定要点评？`,
            `点评练习 - ${this.studentPracticeDetail.homework.title}`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              const data = {
                star_num:
                  this.commentInfo.tinySpot > 0 ? this.commentInfo.tinySpot : 0,
                content: this.commentInfo.practiceText,
                student_answer_id:
                  this.studentPracticeDetail.student_answer.student_answer_id,
                redo: 2,
              };
              if (this.commentInfo.tinySpot > 0) {
                data.star_num;
              }
              correct(data).then((res) => {
                if (res.error_code === 0) {
                  this.$message({
                    type: "success",
                    message: "点评完成",
                  });
                  // 视频推荐
                  if (this.commentInfo.recommend) {
                    homeworkVideoRecommendApi({
                      title: this.commentInfo.videoTitle,
                      video: recommendTarget.object_key,
                      // student_id: Number(
                      //   this.studentPracticeDetail.student.student_id
                      // ),
                      // homework_id: Number(
                      //   this.studentPracticeDetail.homework_id
                      // ),
                      homework_student_id: Number(
                        this.studentPracticeDetail.homework_student_id
                      ),
                    });
                  }
                  this.handleFinish();
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    handleRecommendChange() {
      if (!this.commentInfo.recommend) {
        this.studentPracticeDetail.student_answer.content_list.map((it) => {
          it.checked = false;
        });
      }
    },
    retransmission() {
      // 检查推荐相关内容
      let recommendTarget;
      if (this.commentInfo.recommend) {
        recommendTarget =
          this.studentPracticeDetail.student_answer.content_list.find(
            (annex) => {
              return annex.checked;
            }
          );
        if (!recommendTarget) {
          this.$message({
            type: "warning",
            message: "请先选择推荐视频",
          });
          return false;
        }
        if (!this.commentInfo.videoTitle) {
          this.$message({
            type: "warning",
            message: "请先填写推荐视频标题",
          });
          return false;
        }
      }
      this.$refs["comment"].validate((valid) => {
        if (valid) {
          this.$confirm(
            `确定将练习再次发布给学员 “${this.studentPracticeDetail.student.name}”，让学员可以再次上传练习内容，确定要重新发布？`,
            `重新发布 - ${this.studentPracticeDetail.homework.title}`,
            {
              confirmButtonText: "确定",
              confirmButtonClass: "mwow-button-filled success mini",
              cancelButtonText: "取消",
              cancelButtonClass: "mwow-button-filled mini",
              type: "warning",
            }
          )
            .then(() => {
              const data = {
                star_num:
                  this.commentInfo.tinySpot > 0 ? this.commentInfo.tinySpot : 0,
                content: this.commentInfo.practiceText,
                student_answer_id:
                  this.studentPracticeDetail.student_answer.student_answer_id,
                redo: 1,
              };
              if (this.commentInfo.tinySpot > 0) {
                data.star_num;
              }
              correct(data).then((res) => {
                if (res.error_code === 0) {
                  this.$message({
                    type: "success",
                    message: "点评并重发完成",
                  });
                  // 视频推荐
                  if (this.commentInfo.recommend) {
                    homeworkVideoRecommendApi({
                      title: this.commentInfo.videoTitle,
                      video: recommendTarget.object_key,
                      homework_student_id: Number(
                        this.studentPracticeDetail.homework_student_id
                      ),
                    });
                  }
                  this.handleFinish();
                }
              });
            })
            .catch(() => {});
        }
      });
    },
    openInNewPage(v) {
      window.open(v, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
.correct-dialog-wrap {
  .card-wrap {
    padding-bottom: 16px;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .card-title {
      font-size: 16px;
      color: #333;
      line-height: 16px;
      font-weight: bold;
      margin-bottom: 16px;
      &.flex {
        display: flex;
        align-items: center;
      }
    }
    .base-wrap {
      display: flex;
      align-items: center;
      .avatar {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #cdcdcd;
        margin-right: 20px;
      }
      .info {
        flex: 1;
        font-size: 14px;
        line-height: 30px;
        color: #333;
      }
      .status {
        height: 32px;
        border-radius: 50%;
        text-align: center;
        line-height: 32px;
        padding: 0 12px;
        border-radius: 4px;
        font-size: 14px;
        border: 1px solid;
        &.wait {
          border-color: #ff9522;
          color: #ff9522;
        }
        &.finish {
          border-color: #07d1aa;
          color: #07d1aa;
        }
      }
    }
    .comment-wrap {
      .row {
        display: flex;
        align-items: center;
      }
      .item {
        flex: 1;
        display: inline-flex;
        align-items: center;
        min-height: 36px;
        .label {
          margin-right: 12px;
        }
        .content {
          flex: 1;
        }
      }
    }
    .content-wrap {
      .item {
        display: inline-block;
        vertical-align: top;
        margin: 0 12px 12px 0;
        &.block {
          display: block;
          margin-right: 0;
        }
        &:hover {
          .open {
            display: block;
          }
        }
        .open {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.3);
          z-index: 100;
          text-align: center;
          display: none;
          cursor: pointer;
          .el-icon-zoom-in {
            position: relative;
            top: 50%;
            margin-top: -12px;
            font-size: 24px;
            color: #fff;
            line-height: 24px;
          }
        }
        .border {
          border: 1px solid #f2f2f2;
          border-radius: 4px;
          overflow: hidden;
        }
        .img-box {
          font-size: 0;
          position: relative;
          max-height: 140px;
          max-width: 140px;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
        .video-box {
          font-size: 0;
          position: relative;
          max-height: 140px;
          max-width: 140px;
          overflow: hidden;
          video {
            width: 100%;
            height: auto;
          }
        }
        .checked-wrap {
          padding: 4px 0 4px 8px;
        }
        .text-wrap {
        }
      }
    }
    .start-wrap {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      .label {
        padding: 0 12px 0 33px;
      }
    }
    .correct-wrap {
    }
  }
  .bottom-button {
    text-align: right;
    .mwow-button-filled {
      margin-left: 12px;
    }
  }
}
/deep/ .el-form {
  .el-textarea__inner {
    width: 100%;
  }
}
</style>
